import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
import { awaitTimeout } from "@/utils/GlobalJavascriptFunction";
var _api__getFinanceUploadDocuments = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(uuid) {
    var _response$data, _response$data$data, _response$data$data$f, _response$data2;
    var isRetry,
      params,
      response,
      _args = arguments;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          isRetry = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
          params = {
            order_uuid: uuid
          };
          _context.n = 1;
          return fetcher().get("finance/get-finance-upload-documents", {
            params: params
          });
        case 1:
          response = _context.v;
          if (!((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$data = _response$data.data) === null || _response$data$data === void 0 ? void 0 : (_response$data$data$f = _response$data$data.filesDataCanSubmit) === null || _response$data$data$f === void 0 ? void 0 : _response$data$data$f.length) === 0)) {
            _context.n = 4;
            break;
          }
          if (!isRetry) {
            _context.n = 2;
            break;
          }
          return _context.a(2, Promise.reject({
            message: "No {filesDataCanSubmit} files found"
          }));
        case 2:
          _context.n = 3;
          return awaitTimeout(2000);
        case 3:
          return _context.a(2, _api__getFinanceUploadDocuments(uuid, true));
        case 4:
          if (!((response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.code) === 230)) {
            _context.n = 5;
            break;
          }
          return _context.a(2, Promise.reject({
            name: "ValidationException"
          }));
        case 5:
          return _context.a(2, response.data.data || []);
      }
    }, _callee);
  }));
  return function api__getFinanceUploadDocuments(_x) {
    return _ref.apply(this, arguments);
  };
}();
export { _api__getFinanceUploadDocuments as api__getFinanceUploadDocuments };